export const AGENTS_PLATFORM_INDEX_ROUTE = 'agents_platform_index_route';
export const AGENTS_PLATFORM_SHOW_ROUTE = 'agents_platform_show_route';
export const AGENTS_PLATFORM_NEW_ROUTE = 'agents_platform_new_route';
// Map workflow end messages to the new page
export const WORKFLOW_END_PAGE_LINK = 'workflow-new';

// Flow triggers routes
export const FLOW_TRIGGERS_INDEX_ROUTE = 'flow_triggers_index_route';
export const FLOW_TRIGGERS_NEW_ROUTE = 'flow_triggers_new_route';
export const FLOW_TRIGGERS_EDIT_ROUTE = 'flow_triggers_edit_route';
